import React, { useEffect } from "react";
import EquityDiversityInclusionImg from '../Images/EquityDiversity.jpg';
import UrlTag from "../components/UrlTag";
import { Link } from "react-router-dom";

function EquityDiversityInclusion() {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="z-20">
            <UrlTag />
            <div className="relative">
                <img src={EquityDiversityInclusionImg} alt="Equity, Diversity and Inclusion" className="w-full h-[300px] md:h-[500px] object-cover" />
                <div className="absolute inset-0 bg-black opacity-40"></div>
                <div className="absolute bottom-0 left-0 py-4 md:py-8 px-4 md:px-14">
                    <h1 className="text-white text-2xl md:text-4xl font-bold">Equity, Diversity and Inclusion</h1>
                </div>
            </div>
            <div className="p-4 md:p-16 max-w-[620px] mx-auto">
                <div className="mb-10">
                    <h1 className="text-xl md:text-2xl mb-4 tracking-wider">
                        Equity, Diversity and Inclusion
                    </h1>
                    <p className="text-base md:text-lg mb-6 tracking-wider text-gray-700 font-light">
                        Architetive Designs is committed to prioritising equity, diversity and inclusivity, and strives to create a working environment that is supportive and respectful of different cultures and identities.
                    </p>
                    <p className="text-base md:text-lg mb-6 tracking-wider text-gray-700 font-light">
                        We programme a range of equity, diversity and inclusion (EDI) initiatives which aim to embed inclusion and belonging across the practice.
                    </p>
                    <p className="text-base md:text-lg mb-6 tracking-wider text-gray-700 font-light">
                        To support this focus, we have formed a series of EDI employee networks to harness lived experience and improve engagement, awareness and knowledge sharing.
                    </p>
                    <p className="text-base md:text-lg mb-6 tracking-wider text-gray-700 font-light">
                        Each group aims to support our people in the workplace and provide valuable lived experience in support of best practice. Championing equity, diversity and inclusion in the architectural profession sits front and centre in all we do.
                    </p>
                    <p className="text-base md:text-lg mb-6 tracking-wider text-gray-700 font-light">
                        We have well-established links with a number of schools and universities around the world, funding awards and prizes and supporting educational activities. Our internship and apprenticeship programmes provide valuable experience to students from a wide range of backgrounds. We also have strong links with Blueprint for all and Black Professionals in Construction (BPIC Network).
                    </p>
                    <p className="text-base md:text-lg tracking-wider text-gray-700 font-light">
                        As an environmentally driven studio, we aim to practice what we preach. Over recent years we have developed an analytical framework for our own office, based on our bespoke Architetive Designs Responsibility Framework (FRF). This covers ten sustainability related themes - Wellbeing, Community Impact, Energy and Carbon, Mobility and Connectivity, Resources, Water, Land and Ecology, Social Equity, Planning for Change, and Feedback - and informs our CSER policy.
                    </p>
                </div>
                <div className="mb-10">
                    <h1 className="text-xl md:text-2xl mb-4 tracking-wider">
                        Careers at Architetive Designs
                    </h1>
                    <p className="text-base md:text-lg mb-6 tracking-wider text-gray-700 font-light">
                        Architetive Designs is an equal opportunities employer committed to equity, diversity and inclusion as an integral and essential part of the practice. Equity and inclusion lie at the heart of all we do.
                    </p>
                    <p className="text-base md:text-lg mb-6 tracking-wider text-gray-700 font-light">
                        As a global practice with over 65 spoken languages across our workforce, we thrive on the unique qualities of our diverse community.
                    </p>
                    <p className="text-base md:text-lg mb-6 tracking-wider text-gray-700 font-light">
                        Through a range of inspirational and motivational talks and training, as well as intranet features, we embed inclusion and belonging best practice across all aspects of our workforce culture.
                    </p>
                    <p className="text-base md:text-lg mb-6 tracking-wider text-gray-700 font-light">
                        We are always looking for exceptional people to join our innovative, international team. The practice is open and dynamic and we welcome the very best talent from all cultures, ethnicities and identities to join us.
                    </p>
                    <Link to='/careers/vacancies'>
                        <button className="text-gray-600 bg-[#eeeeee] hover:bg-[#e6e6e6] rounded-full px-4 py-1">Vacancies</button>
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default EquityDiversityInclusion;